<template>
    <v-btn
        @click.stop="$emit('click')"
        icon>
        <v-icon v-if="!src"
             class="item-expanded-icon"
             :class="{'item-expanded-icon__expand': expanded}">{{ icon || 'mdi-chevron-down' }}</v-icon>
        <img v-else :src="src"
             class="item-expanded-icon"
             :class="{'item-expanded-icon__expand': expanded}">
    </v-btn>
</template>

<script>
export default {
    name: "FormTableTdExpanded",
    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: undefined,
        },
        src: {
            type: String,
            default: undefined,
        },
    }
}
</script>

<style scoped>
    .item-expanded-icon {
        transition: transform .3s ease-in-out;
    }

    .item-expanded-icon__expand {
        transform: rotate(-180deg);
    }
</style>